import AdminCityList from './cityList';

export default AdminCityList;